import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { NavLink } from 'react-router-dom';
import { Theme } from '../../config/theme';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import Body from '../../components/Body';

class SettingsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Body hasFooter>
        <div className={css(styles.header_container)}>
          <h1 className={css(styles.title)}>My account</h1>
          <div className={css(styles.links)}>
            <NavLink
              to="/settings/profiles"
              className={css(styles.nav_item)}
              activeClassName={css(styles.nav_item_active)}>
              My Details
            </NavLink>
            <NavLink
              to="/settings/membership"
              className={css(styles.nav_item)}
              activeClassName={css(styles.nav_item_active)}>
              My Membership
            </NavLink>
            <NavLink
              to="/settings/account"
              className={css(styles.nav_item)}
              activeClassName={css(styles.nav_item_active)}>
              My Settings
            </NavLink>
            <NavLink
              to="/settings/resources"
              className={css(styles.nav_item)}
              activeClassName={css(styles.nav_item_active)}>
              My Dog e-Bag
            </NavLink>
            <NavLink
              to="/settings/help"
              className={css(styles.nav_item)}
              activeClassName={css(styles.nav_item_active)}>
              Help
            </NavLink>
          </div>
        </div>
        <div className={css(styles.view_container)}>
          {this.props.children}
        </div>
      </Body>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
  view_container: {
    paddingTop: 30,
    paddingBottom: 40,
  },
  header_container: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Theme.lighter_grey,
    height: 280,

    [Theme.mobile_query]: {
      height: 'auto',
      paddingTop: 80,
    },
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 45,
    textAlign: 'center',
    color: Theme.black,
    fontWeight: Theme.font_weight_heading,

    [Theme.mobile_query]: {
      fontSize: 28,
      marginBottom: 50,
    },
  },
  links: {
    position: 'absolute',
    bottom: 20,

    [Theme.mobile_query]: {
      position: 'static',
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 30,
    },
  },
  nav_item: {
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    letterSpacing: 1,
    color: Theme.dark_grey,
    transition: 'all 160ms ease-in-out',
    marginLeft: 25,
    marginRight: 25,
    ':hover': {
      color: Theme.primary,
    },

    [Theme.mobile_query]: {
      width: '100%',
      marginBottom: 20,
      textAlign: 'center',
      marginLeft: 0,
      marginRight: 0,
    },
  },
  nav_item_active: {
    color: Theme.primary,
    ':after': {
      content: "' '",
      display: 'block',
      position: 'absolute',
      width: '100%',
      backgroundColor: Theme.primary,
      height: 3,
      bottom: -17,
      left: 0,

      [Theme.mobile_query]: {
        content: 'none',
      },
    },
  },
});

SettingsContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

SettingsContainer.defaultProps = {
  children: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer);



// WEBPACK FOOTER //
// ./src/views/SettingsContainer/index.js